/**
 * Visualization grid layout primitives.
 *
 * Shared grid constants and styled components are re-exported from
 * @atlas-int/viz. App-specific containers that depend on the global
 * page grid (GlobalGrid) are defined here.
 */

import styled from "@emotion/styled";
import { gridLines as globalGridLines } from "@atlas-int/tokens/layout";
import {
  spacing,
  mediaBelow,
  border as borderToken,
  surface,
} from "@atlas-int/tokens";
import { gridLines, gridAreas } from "@atlas-int/viz";

// ── Re-export shared grid primitives from the package ────────────────
export {
  gridLines,
  gridAreas,
  VisualizationTitleContainer,
  VisualizationTitleBase,
  IntraRegionTradeDisclaimerContainer,
  VisualizationGrid,
  VisualizationContentContainer,
  VisualizationBottomRowContainer,
  VisualizationHandlesContainer,
  VisualizationTotalContainer,
  TotalValueLabel,
} from "@atlas-int/viz";

// ── App-specific containers (depend on global page grid) ─────────────

export const VisualizationContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: ${spacing[0]};
  box-sizing: border-box;
  overflow: hidden;

  display: grid;
  column-gap: ${spacing[8]};
  grid-template-columns:
    [ ${globalGridLines.globalMainContentAreaLeft}] minmax(0, 1fr)
    [ ${globalGridLines.globalMainContentAreaRight}];
  grid-template-rows:
    [ ${globalGridLines.globalPageTop} ${gridLines.visualizationControlsTop}] auto
    [ ${gridLines.visualizationControlsBottom} ${gridLines.titleHeaderTop}] auto
    [ ${gridLines.titleHeaderBottom} ${gridLines.visualizationContentTop}] minmax(
      0,
      1fr
    )
    [ ${globalGridLines.globalPageBottom}];
  grid-template-areas:
    "${gridAreas.controls}"
    "${gridAreas.visualizationTitle}"
    "${gridAreas.visualization}";
`;

export const ControlsContainer = styled.div`
  grid-area: ${gridAreas.controls};
  background-color: ${surface.controls};
  display: flex;
  padding: ${spacing[4]} ${spacing[8]};
  padding-bottom: ${spacing[6]};
  padding-top: 25px;
  position: relative;
  border-bottom: 1px solid ${borderToken.divider};

  ${mediaBelow("lg")} {
    padding-left: ${spacing[6]};
    padding-right: ${spacing[6]};
  }

  ${mediaBelow("md")} {
    padding-left: ${spacing[3]};
    padding-right: ${spacing[3]};
  }
`;

export const ControlsInputsRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: ${spacing[4]} clamp(4px, 1vw, 16px);
  width: 100%;
`;
